import React from 'react';
import { motion } from 'framer-motion';
import { WaitlistForm } from './WaitlistForm';
import { ShieldCheck, Users, Zap } from 'lucide-react';
interface HeroProps {
  onSignup?: (email: string) => void;
}
export function Hero({
  onSignup
}: HeroProps) {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-slate-900" data-id="element-66">
      {/* Abstract Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-67">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-blue-500/5 blur-[120px]" data-id="element-68" />
        <div className="absolute bottom-[10%] -left-[10%] w-[50%] h-[50%] rounded-full bg-blue-500/10 blur-[100px]" data-id="element-69" />

        {/* Grid Pattern */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMSIgY3k9IjEiIHI9IjEiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4wNSkiLz48L3N2Zz4=')] opacity-50" data-id="element-70" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-71">
        <div className="text-center max-w-4xl mx-auto" data-id="element-72">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-800 border border-slate-700 mb-8" data-id="element-73">
            <span className="flex h-2 w-2 rounded-full bg-blue-500 animate-pulse" data-id="element-74"></span>
            <span className="text-xs font-medium text-slate-300 uppercase tracking-wider" data-id="element-75">
              Accepting Waitlist Signups
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-5xl md:text-6xl lg:text-7xl font-display font-bold text-white tracking-tight leading-[1.1] mb-6" data-id="element-76">
            Stop Losing Drivers to <br className="hidden md:block" data-id="element-77" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600" data-id="element-78">
              Slow Hiring
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-lg md:text-xl text-slate-400 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-79">
            Lighthouse AI screens, qualifies, and hires drivers automatically —
            so you can fill seats faster and keep trucks moving.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="mb-8" data-id="element-80">
            <WaitlistForm buttonSize="large" onSignup={onSignup} data-id="element-81" />
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-slate-400" data-id="element-82">
            <div className="flex items-center gap-2" data-id="element-83">
              <Users className="w-4 h-4 text-blue-500" data-id="element-84" />
              <span data-id="element-85">Join your peers</span>
            </div>
            
            
            <div className="hidden sm:block w-1 h-1 rounded-full bg-slate-700" data-id="element-86" />
            <div className="flex items-center gap-2" data-id="element-87">
              <Zap className="w-4 h-4 text-blue-500" data-id="element-88" />
              <span data-id="element-89">Setup in minutes</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}